import React from "react";
import { Navigate } from "react-router-dom";
import { useIntl } from "react-intl";
import Countdown from "react-countdown";

type CounterDownProps = {
  seconds?: number;
};

export default function CountDown({ seconds = 60000 }: CounterDownProps) {
  const { formatMessage } = useIntl();
  return (
    <Countdown
      date={Date.now() + seconds}
      renderer={(props) => {
        if (props.completed) {
          return <Navigate to="/logout" />;
        } else {
          return (
            <div className="Timer">
              {props.total / 1000}
              {formatMessage({ id: "hyvendor.column.second" })}
            </div>
          );
        }
      }}
    />
  );
}
